import React, { useEffect, useState } from "react";

function Stock({ variation }) {

    const instock = (variation) => {
        if (variation.available_quantity > 0) {
            return true
        } else if (variation.backorder) {
            return true
        } else {
            return false
        }
    }


    return (
        <>
            {instock(variation) ? (
                <>

                    {(variation.available_quantity > 0) ? (
                        <>
                            <div className="text-green-700 font-medium text-base mb-2 leading-none">
                                <i className="fas fa-check-circle mr-1"></i> {(variation.available_quantity > 50 ? '50+' : variation.available_quantity)} In Stock
                            </div>
                        </>
                    ) : (
                        <>
                            {/* <div className="text-red-700 font-medium text-base mb-2 leading-none">
                                <i className="fas fa-check-circle"></i> Out of Stock
                            </div> */}
                            <div className="text-sm text-gray-600">
                                {(variation.lead_time_value) ?
                                    (
                                        (variation.lead_time_units == 'Day(s)' || variation.lead_time_units == 'Days') ? (
                                            <>
                                                Lead Time Approx. <br></br><strong className="text-xs">{Number(variation.lead_time_value) + Number(1)} Working Day(s)</strong>
                                            </>
                                        ) : (
                                            <>
                                                Lead Time Approx. <br></br><strong className="text-xs">{variation.lead_time_value} {(variation.lead_time_units == 'Week(s)' || variation.lead_time_units == 'Weeks') ? ('Week(s)'):('Month(s)')}</strong>
                                            </>
                                        )
                                    ) : (
                                        <>
                                            Lead Time Approx. <br></br><strong className="text-xs">2-5 Working Days</strong>
                                        </>
                                    )}
                            </div>
                        </>
                    )}
                </>
            ) : (
                <>
                    {/* <div className="text-red-700 font-medium text-base mb-2 leading-none">
                        <i className="fas fa-check-circle"></i> Out of Stock
                    </div> */}
                    <div className="text-sm text-gray-600">
                        {(variation.lead_time_value) ?
                            (
                                (variation.lead_time_units == 'Day(s)' || variation.lead_time_units == 'Days') ? (
                                    <>
                                        Lead Time Approx. <strong className="text-xs">{Number(variation.lead_time_value) + Number(1)} Working Day(s)</strong>
                                    </>
                                ) : (
                                    <>
                                        Lead Time Approx. <strong className="text-xs">{variation.lead_time_value} {(variation.lead_time_units == 'Week(s)' || variation.lead_time_units == 'Weeks') ? ('Week(s)'):('Month(s)')}</strong>
                                    </>
                                )
                            ) : (
                                <>
                                    Lead Time Approx. <strong className="text-xs">2-5 Working Days</strong>
                                </>
                            )}
                    </div>
                </>

            )}
        </>
    );
}

export default Stock;